<template>
    <Tooltip v-if="visible" text="Product Assistant">
        <v-btn @click="OpenHelpWindow" class="mr-2" icon="mdi-help-circle-outline"/>
    </Tooltip>
</template>

<script>
import Tooltip from "@/components/typography/Tooltip.vue";

export default {
    components: {Tooltip},
    data: () => ({
        visible: false,
    }),
    mounted() {
        if (typeof window.AiAssistantApp != "undefined") {
            this.visible = true;
            console.log(typeof window.AiAssistantApp)
        }
    },
    methods: {
        OpenHelpWindow() {
            window.AiAssistantApp.dispatch('ToggleChatUI')
        }
    }
}
</script>
